<div class="modal-container" fxFlex fxLayout="row">
	<a [appA11yActivate]="{method:'onClose', context:this}" class="close" tabindex="0" [attr.aria-label]="'Common.Controls.Back' | translate">
		<span><</span>
	</a>
	<app-search-bar fxFlex="100" fxLayoutAlign="start center" (searchTerms)="onSearch($event)"></app-search-bar>
</div>